const BASE = (process.env.VUE_APP_API_URL || '') + '/api/v1/todo'

function token() {
  return localStorage.getItem('todo_token')
}

async function request(method, path, body = null) {
  const headers = { 'Content-Type': 'application/json' }
  const t = token()
  if (t) headers['Authorization'] = 'Bearer ' + t

  const opts = { method, headers }
  // Always send a JSON body for write methods. The server's mod_security rejects
  // bodyless POST/PUT/PATCH with a 403, which would silently break action
  // endpoints (complete, reopen, archive, restore, timer start/stop) that send no body.
  if (body !== null) {
    opts.body = JSON.stringify(body)
  } else if (method === 'POST' || method === 'PUT' || method === 'PATCH') {
    opts.body = '{}'
  }

  const res  = await fetch(BASE + path, opts)
  const json = await res.json().catch(() => ({}))

  if (!res.ok) {
    const msg = json.message || json.error || 'Request failed'
    throw Object.assign(new Error(msg), { status: res.status, data: json })
  }
  return json
}

const api = {
  // Auth
  // Pass { email, password } for internal users, { username, password } for external clients.
  login:  (credentials) => request('POST', '/auth/login', credentials),
  logout: ()            => request('POST', '/auth/logout'),
  me:     ()            => request('GET',  '/auth/me'),

  // Projects
  getProjects: (params = {}) => {
    const qs = new URLSearchParams(
      Object.fromEntries(Object.entries(params).filter(([, v]) => v !== null && v !== undefined && v !== ''))
    ).toString()
    return request('GET', '/projects' + (qs ? '?' + qs : ''))
  },
  createProject:  (data)  => request('POST', '/projects', data),
  reorderProjects:(ids)   => request('POST', '/projects/reorder', { ids }),
  updateProject:  (id, d) => request('PUT',  '/projects/' + id, d),
  archiveProject: (id)    => request('POST', '/projects/' + id + '/archive'),
  restoreProject: (id)    => request('POST', '/projects/' + id + '/restore'),
  getProjectMembers:   (id)        => request('GET',    '/projects/' + id + '/members'),
  addProjectMember:    (id, uid)   => request('POST',   '/projects/' + id + '/members', { user_id: uid }),
  removeProjectMember: (id, uid)   => request('DELETE', '/projects/' + id + '/members/' + uid),
  getProjectClients:   (id)        => request('GET',    '/projects/' + id + '/clients'),
  addProjectClient:    (id, cid)   => request('POST',   '/projects/' + id + '/clients', { client_id: cid }),
  removeProjectClient: (id, cid)   => request('DELETE', '/projects/' + id + '/clients/' + cid),

  // Tasks
  getTasks: (params = {}) => {
    const qs = new URLSearchParams(
      Object.fromEntries(Object.entries(params).filter(([, v]) => v !== null && v !== undefined && v !== ''))
    ).toString()
    return request('GET', '/tasks' + (qs ? '?' + qs : ''))
  },
  getTask:      (id)     => request('GET',  '/tasks/' + id),
  createTask:   (data)   => request('POST', '/tasks', data),
  reorderTasks: (ids)    => request('POST', '/tasks/reorder', { ids }),
  updateTask:   (id, d)  => request('PUT',  '/tasks/' + id, d),
  archiveTask:  (id)     => request('POST', '/tasks/' + id + '/archive'),
  restoreTask:  (id)     => request('POST', '/tasks/' + id + '/restore'),
  completeTask: (id)     => request('POST', '/tasks/' + id + '/complete'),
  reopenTask:   (id)     => request('POST', '/tasks/' + id + '/open'),
  timerStart:   (id)     => request('POST', '/tasks/' + id + '/timer/start'),
  timerStop:    (id)     => request('POST', '/tasks/' + id + '/timer/stop'),

  // Subtask grid (checklist + custom columns)
  getSubtasks:         (tid)        => request('GET',    '/tasks/' + tid + '/subtasks'),
  addSubtask:          (tid, data)  => request('POST',   '/tasks/' + tid + '/subtasks', data),
  updateSubtask:       (tid, sid, d)=> request('PUT',    '/tasks/' + tid + '/subtasks/' + sid, d),
  deleteSubtask:       (tid, sid)   => request('DELETE', '/tasks/' + tid + '/subtasks/' + sid),
  reorderSubtasks:     (tid, ids)   => request('POST',   '/tasks/' + tid + '/subtasks/reorder', { ids }),
  addSubtaskColumn:    (tid, data)  => request('POST',   '/tasks/' + tid + '/subtask-columns', data),
  updateSubtaskColumn: (tid, cid, d)=> request('PUT',    '/tasks/' + tid + '/subtask-columns/' + cid, d),
  deleteSubtaskColumn: (tid, cid)   => request('DELETE', '/tasks/' + tid + '/subtask-columns/' + cid),

  // Task comments (two-way)
  getComments: (tid)       => request('GET',  '/tasks/' + tid + '/comments'),
  addComment:  (tid, body) => request('POST', '/tasks/' + tid + '/comments', { body }),

  // Work requests (client submits; manager/dev reviews; negotiation via revise/accept)
  getRequests:     ()        => request('GET',  '/requests'),
  createRequest:   (data)    => request('POST', '/requests', data),
  updateRequest:   (id, d)   => request('PUT',  '/requests/' + id, d),         // client counter → pending
  approveRequest:  (id, d={})=> request('POST', '/requests/' + id + '/approve', d),
  declineRequest:  (id)      => request('POST', '/requests/' + id + '/decline'),
  reviseRequest:   (id, d)   => request('POST', '/requests/' + id + '/revise', d), // manager propose changes
  acceptRequest:   (id)      => request('POST', '/requests/' + id + '/accept'),    // client accept revision

  // Internal users (assignee picker)
  getUsers: () => request('GET', '/users'),

  // Per-user draggable dashboard
  getDashboardLayout: ()       => request('GET', '/dashboard/layout'),
  saveDashboardLayout: (layout)=> request('PUT', '/dashboard/layout', { layout }),
  getDashboardFeed: ()         => request('GET', '/dashboard/feed'),

  // Realtime team activity (manager)
  getActivity: () => request('GET', '/activity'),

  // External clients
  getClients:   ()       => request('GET',  '/clients'),
  createClient: (data)   => request('POST', '/clients', data),
  updateClient: (id, d)  => request('PUT',  '/clients/' + id, d),
}

export default api
